import { LoginForm, useAuthStore } from '@/features/auth';
import { Widget } from '@/layout';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/chat')({
  component: ChatComponent
});

function ChatComponent() {
  useEffect(() => {
    useAuthStore.getState().load();
  }, []);

  return (
    <>
      {import.meta.env.MODE !== 'production' && <LoginForm />}
      <Widget />
    </>
  );
}
